import { Grid, Typography } from '@mui/material';
import { HourglassEmptyOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import { formatTime } from '../../../../../utils';

export default function WaitApprovalPage() {
  const { event } = useSelector((store) => store.events);

  return (
    <div>
      <Grid container justifyContent="center" marginY={2}>
        <HourglassEmptyOutlined />
        <Typography>You must wait for a venue to approve your application</Typography>
      </Grid>

      <SimpleCard variant="outlined">
        <Grid container justifyContent="center" mb={2}>
          <Grid item>
            <Typography fontWeight="bold">Check in:</Typography>
          </Grid>
          <Grid item>
            <Typography marginLeft={2}>
              Starts at {formatTime(event?.parameters_event.hour_start_event)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item>
            <Typography fontWeight="bold">Got it!</Typography>
            <Typography>If you have any questions, check out the event page</Typography>
          </Grid>
        </Grid>
      </SimpleCard>
    </div>
  );
}
